import React from 'react';
import connectWithStore from '../../utils/store'
import { store } from '../../store'
import TilbodNavigation from '../tilbod-navigation'
import Quote from '../quote'
import Modal from 'react-modal';
import {SigningModal} from '../modals' 

class TilbodStepShowQuote extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        let customers = this.props.customers;


        return (
            <>

                <Quote store={this.props.store} />
                
                <TilbodNavigation />

                <SigningModal isOpen={this.props.gui.signingModalOpen} store={this.props.store} />
            </>
        )
    }
}

TilbodStepShowQuote.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        infoCollection: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    return f;
}

export default connectWithStore(store, TilbodStepShowQuote, mapStateToProps);
